import React, { useState, useEffect } from 'react';
import { $t } from "@/modules/i18n";

export default ({ message }) => {
  const [hash, setHash] = useState("");
  const [menuShow, setMenuShow] = useState(false);

  const updateHash = () => {
    setHash(window.location.hash);
  }

  function handleScroll() {
    const aboutEl = document.getElementById('about');
    const applyEl = document.getElementById('apply');
    const timeEl = document.getElementById('time');
    const requiredEl = document.getElementById('required');
    const faqEl = document.getElementById('faq');
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    const offset = 5;
    if(scrollTop >= aboutEl.offsetTop - offset && scrollTop < applyEl.offsetTop - offset) {
      setHash('#about');
    } else if(scrollTop >= applyEl.offsetTop - offset && scrollTop < timeEl.offsetTop - offset){
      setHash('#apply');
    } else if(scrollTop >= timeEl.offsetTop - offset && scrollTop < requiredEl.offsetTop - offset){
      setHash('#time');
    } else if(scrollTop >= requiredEl.offsetTop - offset && scrollTop < faqEl.offsetTop - offset){
      setHash('#required');
    } else if(scrollTop >= faqEl.offsetTop - offset){
      setHash('#faq');
    } else {
      setHash('');
    }
  }

  

  useEffect(() => {
    window.addEventListener("hashchange", updateHash);
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);


    return () => {
      window.removeEventListener("hashchange", updateHash);
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    }
  }, []);

  useEffect(() => {
    setHash(window.location.hash);
  }, []);

  return (
    <div className="sub-nav">
      <div className="sub-container">
        {
          message.map((item, index) => {
            return (
              <div className={`nav-item${hash === item.href ? " active" : ""}`}>
                <a className="nav-link" href={item.href}>{$t(item.text)}</a>
              </div>
            )
          })
        }
      </div>
    </div>
  )
}